import _define from './define';

// This var hold a temporal value that can be overriden if loadLifter is
// alredy declare in the global (window) scope
let selfDefine = _define;

// Global Export
if (!window.define) {
  window.define = selfDefine;
  window.__lift = window.define;

} else if (window.define.lift) {

  // Use the first installed instance.
  selfDefine = window.define;

} else {
  // This is useful when testing in dev, so i'm going to leave the console.log
  // eslint-disable-next-line no-console,no-inline-comments
  console.warn('loadLifter can not be instantiated, window.define is used by another library'); // NOSONAR
}

export const define = selfDefine;
export default define;
